/** Database of partners integrating Passkeys. */
const PARTNERS = {
  // AmmoCrypt.
  '4753217e-3c1a-4f6e-9b53-0117b95329dd': {
    domains: ['*.ammocrypt.io', 'ammocrypt.io'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
        'yeet_matic_1d3e2de5',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // BENQI (production).
  'c003e85a-fb58-4526-b107-2aac37f4c2c0': {
    domains: ['app.benqi.fi'],
    assets: {
      additionalEnabled: [
        //
        'avalanchec',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // BENQI (dev/staging).
  '75a7c2d1-aced-40c3-9d3e-6e0bc51ea4d9': {
    domains: ['dev.benqi.fi', 'beta.benqi.fi'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Blitz (production).
  '595268c3-d423-41a3-b69e-d9573de5334c': {
    domains: ['app.blitz.exchange'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Blitz (dev/staging).
  '547eae7f-4e2f-45e0-8f42-874cad1d49ed': {
    domains: ['testnet.blitz.exchange'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // dotmoovs (production).
  '6c643b2e-f5a2-49c0-b760-a2b50a5b1d5f': {
    domains: ['web3battles.dotmoovs.ai'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // dotmoovs (dev/staging).
  'e0c5b18b-4f31-4c86-b49f-de70457790f5': {
    domains: ['web-battles.vercel.app'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Drift Web (production).
  '11235d81-5c8d-462e-9088-53e0c52d6030': {
    domains: ['app.drift.trade', 'backup.drift.trade'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Drift Web (dev/staging).
  '830af944-cdf9-4bb6-b94c-ec6cefcebbb8': {
    domains: [
      '*.vercel.app', // Deploy previews, e.g. https://protocol-v2-mono-git-luke-dpe-2849-implement-s-7b2b56-drift-web.vercel.app/
      'beta.drift.trade',
    ],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
        'solanadevnet',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Drift Mobile (dev/staging).
  '8f4c5466-3cc3-47ed-a15f-1d17a56c10a2': {
    domains: ['drift.trade'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Gamesprk (production).
  'd68227fb-053f-4a1f-8838-3daf498c1e6f': {
    domains: ['gamesprk.com'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Gamesprk (dev/staging).
  'bd2427fe-48da-4ab7-bd9f-af19fe1859a7': {
    domains: ['staging.gamesprk.com'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // M80 (production).
  'c47dcb89-05c7-4008-9e37-83e3986ca96b': {
    domains: ['m80.gg'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // M80 (dev/staging).
  '85853cb1-8500-4972-8b62-c51c76b244ea': {
    domains: ['staging.m80.gg'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Magic Square.
  '65cbe1f3-140e-481f-81a5-5cd281a77f8c': {
    domains: [
      '*.magic.store',
      'magic.store',
      '*.magicsquare.io',
      'magicsquare.io',
      '*.msq.local',
      'msq.local',
      '*.magicstore.app',
      'magicstore.app',
    ],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
        'sqr_bsc_2fadeb84',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // nume (dev/staging).
  'da1f0093-4343-4282-b3c5-3c8e27bb176b': {
    domains: ['*.nume.test'],
    assets: {
      additionalEnabled: [
        //
        'ethereumsepolia',
      ],
    },
    features: {
      collectibles: false,
      swaps: false,
      fiat: false,
    },
  },
  // Portals (production).
  '9d9a14c6-9d31-4ac9-a332-f0dbef62faef': {
    domains: ['theportal.to'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
  },
  // Portals (dev/staging).
  'fdabce73-01f4-429f-a7cc-6d80247acbd9': {
    domains: ['staging.theportal.to'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
  },
  // Puffer Finance.
  '947308db-a458-4dd9-8969-d604eeff157b': {
    domains: ['*.puffer.fi', 'puffer.fi'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Rarible (production).
  '9ea4af3e-baa7-4ed5-8768-eb9f3b992aee': {
    domains: ['beta.rarible.com', 'rarible.com'],
    assets: {
      additionalEnabled: [
        'astar',
        'basemainnet',
        'bsc',
        'celo',
        'immutable',
        'kroma',
        'matic',
        'moonbeam',
        'rari',
        'zkSync',
      ],
    },
    features: {
      collectibles: true,
    },
  },
  // Rarible (dev/staging).
  'c2118426-d56f-4b14-a790-560e68e4ebe3': {
    domains: [
      'dev.rarible.com',
      'localhost.rarible.com',
      'testnet.rarible.com',
    ],
    assets: {
      additionalEnabled: [
        'astar',
        'basemainnet',
        'bsc',
        'celo',
        'immutable',
        'kroma',
        'matic',
        'moonbeam',
        'rari',
        'zkSync',
      ],
    },
    features: {
      collectibles: true,
    },
  },
  // ShapeShift (production).
  '7d041b66-8869-40dc-92ef-35f05f7e818b': {
    domains: ['app.shapeshift.com'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // ShapeShift (dev/staging).
  '66d4c617-e18d-4100-b568-5df862885015': {
    domains: ['gome.shapeshift.com'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // SNS (production).
  '2eaa3aa6-d60f-4427-95f4-de8b88889503': {
    domains: ['www.sns.id', 'sns.id'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Star Atlas (production).
  '29164ea6-73b7-400b-acb3-d36db5e564ac': {
    domains: [
      'play.staratlas.com',
      'based.staratlas.com',
      'govern.staratlas.com',
    ],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Star Atlas (dev/staging).
  '5e56d56e-86e4-4fb2-8a99-07d337baaeda': {
    domains: [
      'play.stage.staratlas.cloud',
      'govern.stage.staratlas.cloud',
      'sage-lab.stage.staratlas.cloud',
    ],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // THORSwap (production).
  '9b861afc-1b13-4974-b1c1-fe780af7950f': {
    domains: ['*.thorswap.finance', 'thorswap.finance'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'ethereumarbone',
        'matic',
      ],
    },
    features: {
      collectibles: false,
      swaps: false,
    },
  },
  // THORSwap (dev/staging).
  '994f3903-5054-447e-bddf-a57874c973fb': {
    domains: [
      'dev.thorswap.finance',
      '*.swapkit.dev',
      'swapkit.dev',
      '*.vercel.app', // Deploy previews, e.g. https://dex-g0atggs6a-thorswap.vercel.app/swap
    ],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'ethereumarbone',
        'matic',
      ],
    },
    features: {
      collectibles: false,
      swaps: false,
    },
  },
  // VaultCraft.
  'c247e96b-43ed-487f-8b78-51d6a630f0f4': {
    domains: ['app.vaultcraft.io'],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'ethereumarbone',
        'matic',
        'optimism',
        'vcx_ethereum_df18ad33',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // VaultCraft (dev/staging).
  '0beffe6c-8be8-4ec0-9a48-8e80c961045f': {
    domains: ['*.vercel.app'], // Deploy previews, e.g. https://vaultcraft-git-feat-passkey-0xpawp.vercel.app
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'ethereumarbone',
        'matic',
        'optimism',
        'vcx_ethereum_df18ad33',
      ],
    },
    features: {
      collectibles: false,
    },
  },
  // Vertex Protocol.
  'e66ee9f7-1122-4115-9806-ba5c84d8efeb': {
    domains: [
      '*.vertexprotocol.com',
      'vertexprotocol.com',
      '*.netlify.app', // Deploy previews, e.g. https://deploy-preview-2150--vertex-trade-testnet.netlify.app.
    ],
    assets: {
      additionalEnabled: [
        //
        'bsc',
        'ethereumarbone',
        'mantle',
        'matic',
      ],
    },
    features: {
      collectibles: false,
    },
  },
};

/** Database of internal projects integrating Passkeys. */
const INTERNAL = {
  // Passkeys website (`/apps/website`).
  'c61d4722-9ead-4baf-ab9e-f6619e4cc46a': {
    domains: [
      '*.passkeys.foundation',
      'passkeys.foundation',
      '*.passkeys-website.pages.dev', // Deploy previews.
    ],
    assets: {
      // Only Bitcoin, Solana and Ethereum are enabled by default
      additionalEnabled: [],
    },
  },
  // Web3 sandbox apps for QA.
  'f595219b-cc38-4f19-8630-ccf068f36f0a': {
    domains: ['exodusmovement.github.io'],
    assets: {
      // Only Bitcoin, Solana and Ethereum are enabled by default
      additionalEnabled: [],
    },
  },
  // Demo/testing project from @metasal1.
  '77072e8f-4285-48a0-b1c1-511c5105ae50': {
    domains: [
      'staging.metasal.xyz',
      'staging.sol.new',
      'passkeys-react.vercel.app',
      'pdk-next.vercel.app',
      'pdk-anza.vercel.app',
      'solburner.fun',
    ],
    assets: {
      // Only Bitcoin, Solana and Ethereum are enabled by default
      additionalEnabled: [],
    },
  },
};

/** Domains to allow for local testing. */
const LOCAL_DOMAINS = [
  'localhost:*',
  '127.0.0.1:*',
  'http://localhost:*',
  'http://127.0.0.1:*',
];

const DB = {
  ...PARTNERS,
  ...INTERNAL,
};

export { DB, LOCAL_DOMAINS };
